<div class="loader-overlay">
    <div class="progress-circle-indeterminate progress-circle-complete">
    </div>
</div>